import { createRouter, createWebHistory,createMemoryHistory,createWebHashHistory } from 'vue-router'
import routes from './routes'
const createHistory =
    process.env.SERVER
      ? createMemoryHistory
      : process.env.VUE_ROUTER_MODE === 'history'
        ? createWebHistory
        : createWebHashHistory;

        //history: createWebHistory(process.env.BASE_URL),
const router = createRouter({
 history: createHistory(
      process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/auth/login'];
  const authRequired = !publicPages.includes(to.path);  
  const loggedIn = localStorage.getItem('user');
  // trying to access a restricted page + not logged in
  // redirect to login page
   if (to.matched.some(record => record.meta.isPublic)) {
     if (authRequired && loggedIn) {
      return next('/');
      }   
     return next(); 
   }
    if (loggedIn) {
      return next(); 
    } 
 
  next('/auth/login');
  console.log('Logueese!!!!')
});

export default router
